import { TextField } from "@platform/design-system";
import React from "react";
import { Box } from "@mui/system";
import { COVERAGE_FORM } from "@platform/rfp-core";

import { SectionTitle } from "../../components";

type Props = {
  onChange: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  currentPlan: Record<string, string | undefined>;
  handlePreviousFieldsValidation?: (fieldName: string) => void;
};

export default function CommentsField({
  onChange,
  currentPlan,
  handlePreviousFieldsValidation,
}: Props): React.JSX.Element {
  const { ADDITIONAL_NOTES, ALTERNATE_PLANS, COMMENTS } = COVERAGE_FORM;

  return (
    <>
      <SectionTitle display="flex" justifyContent="space-between">
        <span>Alternate Plans</span>
      </SectionTitle>
      {
        <Box pl={2} pr={2}>
          <TextField
            autoComplete="off"
            multiline
            rows={3}
            name={ALTERNATE_PLANS}
            value={currentPlan[ALTERNATE_PLANS] || ""}
            onChange={onChange}
            fullWidth
            label="Add your alternate plan information"
            onFocus={() => {
              if (handlePreviousFieldsValidation) {
                handlePreviousFieldsValidation(ALTERNATE_PLANS);
              }
            }}
          />
        </Box>
      }

      <SectionTitle>Additional Notes</SectionTitle>
      <Box pl={2} pr={2}>
        <TextField
          autoComplete="off"
          multiline
          rows={3}
          name={ADDITIONAL_NOTES}
          value={currentPlan[ADDITIONAL_NOTES] || currentPlan[COMMENTS] || ""}
          onChange={onChange}
          fullWidth
          label="Add your additional notes here"
          onFocus={() => {
            if (handlePreviousFieldsValidation) {
              handlePreviousFieldsValidation(ADDITIONAL_NOTES);
            }
          }}
        />
      </Box>
    </>
  );
}
